import React, { useRef } from "react";
import { FormControl, Card, Layout, Button, usePath, useAppConfig } from "@fdoh/health-ui-react";
import { useHistory, Link, useLocation, useParams } from "react-router-dom";
import { useSubmitForm } from "../../hooks/useSubmitForm";
import { useForm } from "react-hook-form";
import { FilledMoundSystemInspectionInput, schema, FilledMoundSystemInspectionFormProps, ComplianceData, StabilizationData } from "./FilledMoundSystemForm.types";
import { useData } from "../../hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import CSS from 'csstype';
import { Constants, InspectionStatus } from "../../helpers/Constants";
import { toast } from "react-toastify";
import { InspectionStatusInput } from "../InspectionHome/InspectionHome.types";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";


export const FilledMoundSystemInspectionForm = (props: FilledMoundSystemInspectionFormProps) => {
    const history = useHistory();
    const path = usePath();
   // const params = useParams();
    const complianceData = useData<ComplianceData[]>("Compliance") || [];
    const stabilizationData = useData<StabilizationData[]>("Stabilization") || [];
    const inspectionStatusData = useData<InspectionStatusInput>("inspectionDetails/" + props.applicationInspectionId);
    const yesNoData = [
        { id: "", name: "Please select a value" },
        { id: "Yes", name: "Yes" },
        { id: "No", name: "No" }
    ];
    const config =  useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
         const user =  useProfile(application) as UserSecurityInput;
    const { control, handleSubmit, setValue, watch } = useForm<FilledMoundSystemInspectionInput>({
        defaultValues: props.values,
        resolver: yupResolver(schema),
       
    });
    const formRef = useRef<HTMLFormElement>(null);

    function timeout(delay: number) {
        return new Promise(res => setTimeout(res, delay));
    }


    const onSubmit = useSubmitForm<FilledMoundSystemInspectionInput>(
        'filledMoundSystem',
        async (response) => {
            toast.success("Filled Mound System Saved Successfully");
            await timeout(2000);
            let inspectionStatus = watch("inspectionStatusId");
        if(inspectionStatus == InspectionStatus.Complete){
            if(inspectionStatusData?.additionalInformationInspectionId == null 
                || inspectionStatusData?.additionalInformationInspectionId == undefined){
                    history.push({
                        pathname: "/AdditionalInformation/",
                        search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                    })
                }
                else {
                    history.push({
                        pathname: "/AdditionalInformation/"+ inspectionStatusData?.additionalInformationId,
                        search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                    })
                }
        }
        else if (inspectionStatus == InspectionStatus.Incomplete){
            history.push(`/inspectionDetails/${inspectionStatusData?.applicationInspectionId}`) ;
        }
       
           

        },
        props.action
    );



    const submit = () => {
        setValue('applicationId', props.applicationId ? props.applicationId : 0);
        setValue('applicationInspectionId', props.applicationInspectionId ? props.applicationInspectionId : 0);
        if(inspectionStatusData?.filledMoundSystemInspectionId == null 
            || inspectionStatusData?.filledMoundSystemInspectionId == undefined){
                setValue('dateCreated', new Date());
                setValue('createdBy', user?.userName);
            }
            else {
                setValue('dateUpdated', new Date());
                setValue('updatedBy', user?.userName);
            }
        if (formRef.current) {

            formRef.current.dispatchEvent(
                new Event('submit', { cancelable: true, bubbles: true })
            );

        }
    }
  
    let showDrainfieldCoverComment = watch("drainfieldCoverComplianceId");
    let showShoulderComment = watch("shoulderComplianceId");
    let showSlopeComment = watch("slopeComplianceId");
    let showStablizationComment = watch("stablizationComplianceId");
    let markAllCompliance = watch("markAll");

    const h1Styles: CSS.Properties = {
        float: "right",
       marginTop: '27px'
      };
  const markClick = (e: any) => {
    //showSerfaceWaterComment = markAllCompliance;
      setValue('drainfieldCoverComplianceId', markAllCompliance);
      setValue('shoulderComplianceId', markAllCompliance);
      setValue('slopeComplianceId', markAllCompliance);
      setValue('stablizationComplianceId', markAllCompliance);
     
      
    
    e.preventDefault();
      };
     
    return (
       
        <form id={props.id} ref={formRef} onSubmit={handleSubmit((data: FilledMoundSystemInspectionInput) => onSubmit(data))}>
            <div className="row">
                <div className="col col-md-8">
                    <div className="card-main-title">
                        Filled/Mound System
                    </div>
                </div>
                <div className="col col-md-3 ms-auto">
                    <FormControl.Select
                        control={control}
                        name="markAll"
                        label="Mark All"
                        options={complianceData}
                        required
                    />
                </div>
                <div className="col col-md-1" style={h1Styles}>
                    <Button className="btn btn-primary" onClick={markClick} >Apply</Button>
                </div>
            </div>
           
            <Card.Container>
          
                <Card.Header>
                <Card.Title>{props.title}</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Layout.Row>   <>
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="drainfieldCoverComplianceId"
                                    label="Drainfield Cover"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        
                        </div>
                        {showDrainfieldCoverComment &&
                            showDrainfieldCoverComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="drainfieldCoverComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="shoulderComplianceId"
                                    label="Shoulders"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        
                        </div>
                        {showShoulderComment &&
                            showShoulderComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="shoulderComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="slopeComplianceId"
                                    label="Slopes"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showSlopeComment &&
                            showSlopeComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="slopeComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="stablizationComplianceId"
                                    label="Stabilization"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="stablizationId"
                                    label="Stabilization Material"
                                    options={stabilizationData}
                                    required= {showStablizationComment != Constants.Not_Applicable && showStablizationComment !=Constants.Unobserved }
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="ownerAgentResponsible"
                                    label="Owner/Agent Responsible?"
                                    options={yesNoData}
                                    required= {showStablizationComment != Constants.Not_Applicable && showStablizationComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showStablizationComment &&
                            showStablizationComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="stablizationComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                          
                            <div className="col col-md-4" hidden>
                                <FormControl.Text
                                    control={control}
                                    name="inspectionStatusId"
                                    label="Created By"
                                    required
                                />
                                  <FormControl.Hidden
                                    control={control}
                                    name="applicationInspectionId"
                                    required
                                />
                            </div>
                            

                        </div>

                    </></Layout.Row>
                </Card.Body>
                <Card.Footer>
                    <div className="d-flex">
                        <span className="btn btn-link" onClick={(e) => {
                            e.preventDefault();
                            setValue('inspectionStatusId', InspectionStatus.Incomplete);
                            submit()

                        }}><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-arrow-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"></path>
                                <path d="M8 12l4 4"></path><path d="M8 12h8"></path>
                                <path d="M12 8l-4 4"></path>
                            </svg> Save and Exit
                        </span>
                        <div className="btn-list ms-auto">
                            <Link
                                to={props.returnPath ?? path.current}
                                className="btn btn-light"
                                role="button"
                            >
                                Cancel
                            </Link>
                            <Button className="btn btn-primary ms-auto" onClick={(e) => {
                                e.preventDefault();
                                setValue('inspectionStatusId', InspectionStatus.Complete);
                                submit()

                            }}>Next</Button>
                        </div>                       
                    </div>
                </Card.Footer>
            </Card.Container>
        </form>
    );
};

export default FilledMoundSystemInspectionForm;




